import React, { useEffect } from 'react';
import { useTracking } from '../../hooks/useTracking';

interface TrackingScriptsProps {
  gtmId?: string;
  gaMeasurementId?: string;
  fbPixelId?: string;
}

export const TrackingScripts: React.FC<TrackingScriptsProps> = ({
  gtmId,
  gaMeasurementId,
  fbPixelId,
}) => {
  const { GTM_ID, GA_MEASUREMENT_ID, FB_PIXEL_ID } = useTracking();

  // Usar IDs proporcionados o fallback a placeholders
  const finalGtmId = gtmId || GTM_ID;
  const finalGaId = gaMeasurementId || GA_MEASUREMENT_ID;
  const finalFbId = fbPixelId || FB_PIXEL_ID;

  useEffect(() => {
    // Google Tag Manager
    if (finalGtmId && finalGtmId !== 'GTM-XXXXXXX') {
      // GTM script
      const gtmScript = document.createElement('script');
      gtmScript.innerHTML = `
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${finalGtmId}');
      `;
      document.head.appendChild(gtmScript);

      // GTM noscript (para casos sin JavaScript)
      const gtmNoscript = document.createElement('noscript');
      gtmNoscript.innerHTML = `
        <iframe src="https://www.googletagmanager.com/ns.html?id=${finalGtmId}"
        height="0" width="0" style="display:none;visibility:hidden"></iframe>
      `;
      document.body.appendChild(gtmNoscript);

      console.log('Google Tag Manager loaded with ID:', finalGtmId);
    }

    // Google Analytics 4
    if (finalGaId && finalGaId !== 'G-XXXXXXXXXX') {
      const gaScript = document.createElement('script');
      gaScript.async = true;
      gaScript.src = `https://www.googletagmanager.com/gtag/js?id=${finalGaId}`;
      document.head.appendChild(gaScript);

      const gaConfigScript = document.createElement('script');
      gaConfigScript.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${finalGaId}', {
          page_title: document.title,
          page_location: window.location.href
        });
      `;
      document.head.appendChild(gaConfigScript);

      console.log('Google Analytics 4 loaded with ID:', finalGaId);
    }

    // Facebook Pixel
    if (finalFbId && finalFbId !== 'XXXXXXXXXX') {
      const fbScript = document.createElement('script');
      fbScript.innerHTML = `
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '${finalFbId}');
        fbq('track', 'PageView');
      `;
      document.head.appendChild(fbScript);

      // Facebook Pixel noscript
      const fbNoscript = document.createElement('noscript');
      fbNoscript.innerHTML = `
        <img height="1" width="1" style="display:none"
        src="https://www.facebook.com/tr?id=${finalFbId}&ev=PageView&noscript=1"/>
      `;
      document.body.appendChild(fbNoscript);

      console.log('Facebook Pixel loaded with ID:', finalFbId);
    }

    // Cleanup function
    return () => {
      // Remove scripts on unmount if needed
      const scripts = document.querySelectorAll(
        'script[src*="googletagmanager"], script[src*="facebook"]'
      );
      scripts.forEach(script => script.remove());
    };
  }, [finalGtmId, finalGaId, finalFbId]);

  return null; // Este componente no renderiza nada visual
};
